import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal } from '../../Modules/Common/App';
import { CookieConsentModal } from './CookieConsentModal';

export const ConsentChecker = () => {
    const dispatch = useDispatch();
    const consent = useSelector((state) => state.app?.consent);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        if (!isClient) return;

        // Skip during react-snap build
        if (typeof navigator !== 'undefined' && navigator.userAgent.includes('ReactSnap')) {
            return;
        }

        // Show modal only if no consent decision yet
        if (!consent?.status) {
            dispatch(setModal({
                component: <CookieConsentModal />,
                open: true,
                size: 'md',
                disableBackdropClose: true,
            }));
        }
    }, [isClient, consent?.status, dispatch]);

    return null;
};